import React, { FC } from 'react';
import { useButton } from '~Hooks';
import { TransparentButton } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import DeleteIcon from '~Assets/icons/delete.svg';
import styled from '@emotion/styled';

const DeleteButton = styled(TransparentButton)`
  padding: 0px;
  min-width: auto;
`;

interface Props {
  onRemove: () => void;
}

/** Remove button for denomination entries */
const RemoveDenominationButton: FC<Props> = ({ onRemove }) => {
  const removeButton = useButton({
    onClick: onRemove,
  });

  return (
    <DeleteButton {...removeButton}>
      <Icon src={DeleteIcon} width="16px" height="16px" color="var(--colorUIRed)" />
    </DeleteButton>
  );
};

export default RemoveDenominationButton;
